<template>
  <div class="copyright">
      <!-- <a target="_blank" href="https://beian.miit.gov.cn">
        <span class="arial">Copyright</span> 版权所有 可心交友 <span class="arial">2021 粤ICP备18079634号-1</span>
      </a> -->
      <!-- 深圳刷爆网络科技有限公司 2021 粤ICP备18079634号-1
      <br>统一社会信用代码 91440300MA5F3GJP5F -->
      深圳刷爆网络科技有限公司 2021 粤ICP备18079634号 粤网文（2021）3178-470号
      <br>公司地址：深圳市南山区粤海街道深圳湾科技生态园6栋A座8层
      <div style="height: 20px;"></div>
      <!-- <div style="width:300px;margin:0 auto; padding:20px 0;">
          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44049202000284" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
            <img :src="require('../assets/image1/police_icon_1431dcb.png')" style="float:left;"/>
            <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">粤公网安备 44049202000284号</p>
          </a>
      </div> -->
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {},
  data() {
    return {
    };
  },
};
</script>

<style scoped lang="scss">
</style>
